import { configureStore } from '@reduxjs/toolkit';

import addressSlice from 'shared/slice/dummyAddress';
import essDataConsumptionSlice from 'shared/slice/essDataConsumptionSlice';
import essSwitchSlice from 'shared/slice/essSwitchSlice';
import globalOverviewSlice from 'features/globalOverview/slice/globalOverviewSlice';
import hpDataConsumptionSlice from 'shared/slice/hpDataConsumptionSlice';
import hpElectricSwitchSlice from 'shared/slice/hpElectricSwitchSlice';
import hpGasSwitchSlice from 'shared/slice/hpGasSwitchSlice';
import masterControlSelectBySwitchSlice from 'shared/slice/masterControlBySwitchSelectSlice';
import masterControlSelectSlice from 'shared/slice/masterControlSelectSlice';
import mCCommandSlice from 'features/masterControl/slice/mCCommandSlice';
import mCSlice from 'shared/slice/mCSlice';
import messageBoxesSlice from 'features/masterControl/slice/messageBoxesSlice';
import reportStatusSlice from 'features/reportStatus/slice/reportStatusSlice';
import selectedMachinesSlice from 'shared/slice/selectedMachinesSlice';
import telemetryChartDataSlice from 'features/telemetry/slice/telemetryChartDataSlice';
import telemetrySlice from 'features/telemetry/slice/telemetrySlice';
import tesDataConsumptionSlice from 'shared/slice/tesDataConsumptionSlice';
import tesSwitchSlice from 'shared/slice/tesSwitchSlice';
import tgsDataConsumptionSlice from 'shared/slice/tgsDataConsumptionSlice';
import tgsSwitchSlice from 'shared/slice/tgsSwitchSlice';
import masterControlSelectByLocationSlice from 'shared/slice/masterControlSelectByLocationSlice';
import snowSensorSlice from 'features/settings/slice/snowSensorSlice';
import unitsSlice from 'shared/slice/unitsSlice';
import windFactorSlice from 'features/settings/slice/windFactorSlice';
import interfaceModeSlice from 'features/settings/slice/interfaceModeSlice';
import settingsOptionsSlice from 'features/settings/slice/settingsOptionsSlice';
import adminSlice from 'shared/slice/adminSlice';
import EditCancelApplyButtonsSlice from 'features/settings/slice/editCancelApplyButtonsSlice';
import faultsSlice from 'shared/slice/FaultsSlice';
import addElementToBankAndSystemIdentificationSlice from 'features/settings/slice/admin/addElementToBankAndSystemIdentification';
import MCIsExpandedSlice from 'shared/slice/MCIsExpandedSlice';
import userSlice from 'shared/slice/userSlice';
import forceCommandAndAdminSelectSlice from 'features/settings/slice/force&CommandAndAdminSelectSlice';
import forceAndCommandsSlice from 'shared/slice/forceAndCommandsSlice';
import sysIdentificationSlice from 'features/settings/slice/admin/sysIdentificationSlice';
import mobileSelectProgramSlice from 'shared/slice/mobileSelectProgramSlice';
import mobileMasterControlSlice from 'features/masterControl/slice/mobileMasterControlSlice';
import appSlice from 'shared/slice/appSlice';
import ssrUiSlice from 'shared/slice/ssrUiSlice';

























































const store = configureStore({
  reducer: {
    essSwitch: essSwitchSlice.reducer,
    tesSwitch: tesSwitchSlice.reducer,
    tgsSwitch: tgsSwitchSlice.reducer,
    ssrUi: ssrUiSlice.reducer,
    masterControlSelect: masterControlSelectSlice.reducer,
    mC: mCSlice.reducer,
    mCCommand: mCCommandSlice.reducer,
    selectedMachines: selectedMachinesSlice.reducer,
    messageBoxes: messageBoxesSlice.reducer,
    globalOverview: globalOverviewSlice.reducer,
    telemetry: telemetrySlice.reducer,
    masterControlSelectBySwitch: masterControlSelectBySwitchSlice.reducer,
    masterControlSelectByLocation: masterControlSelectByLocationSlice.reducer,
    hpElectricSwitch: hpElectricSwitchSlice.reducer,
    hpGasSwitch: hpGasSwitchSlice.reducer,
    essDataConsumption: essDataConsumptionSlice.reducer,
    tgsDataConsumption: tgsDataConsumptionSlice.reducer,
    tesDataConsumption: tesDataConsumptionSlice.reducer,
    hpDataConsumption: hpDataConsumptionSlice.reducer,
    telemetryChartData: telemetryChartDataSlice.reducer,
    address: addressSlice.reducer,
    reportStatus: reportStatusSlice.reducer,

    admin: adminSlice.reducer,
    forceAndCommands: forceAndCommandsSlice.reducer,
    snowSensor: snowSensorSlice.reducer,
    units: unitsSlice.reducer,
    windFactor: windFactorSlice.reducer,
    interfaceMode: interfaceModeSlice.reducer,
    settingsOptions: settingsOptionsSlice.reducer,
    editCancelApplyButtons: EditCancelApplyButtonsSlice.reducer,
    faultsState: faultsSlice.reducer,
    forceCommandAndAdminSelect: forceCommandAndAdminSelectSlice.reducer,
    addElementToBankAndSystemIdentification:
      addElementToBankAndSystemIdentificationSlice.reducer,
    isExpanded: MCIsExpandedSlice.reducer,
    userInfo: userSlice.reducer,
    sysIdentification: sysIdentificationSlice.reducer,
    selectedProgram: mobileSelectProgramSlice.reducer,
    mobileMasterControl: mobileMasterControlSlice.reducer,
    appInfo: appSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
